module.exports = __webpack_public_path__ + "img/124.8.579d28c7.png";